import { Button, Select } from 'antd';
import React from 'react';
import { VBAI_FINDING_PROPERTIES } from '../../../../../shared/parsers/windTurbineParser';
import { AnnotationStandardDetails } from '../../../../AnnotationManager/AnnotationStandardForm/AnnotationStandardForm.slice';
import style from '../PublishModal.module.scss';
import { FilterConsts, FilterRow } from '../utils';

const { Option } = Select;

type Props = {
  filters: FilterRow[];
  standard: AnnotationStandardDetails | null;
  setFilters: (fitlers: FilterRow[]) => void;
};

const PublishFilters = ({ filters, standard, setFilters }: Props) => {
  const updateSelectedParameter = (filter: FilterRow, value: string) => {
    //update values
    filter.selectedParameter = value;

    var values = standard?.findingTypes[0].findingTypeTemplate?.properties.find(x => x.name === value)?.values;
    if (values) {
      filter.availableValues = values?.split(', ');
    }

    setFilters([...filters]);
  };

  const updateSelectedOperation = (filter: FilterRow, value: string) => {
    filter.selectedOperation = value;
    setFilters([...filters]);
  };
  const updateSelectedValue = (filter: FilterRow, value: string) => {
    filter.selectedValue = value;
    setFilters([...filters]);
  };
  const updateSelectedConjuction = (filter: FilterRow, value: string) => {
    filter.selectedConjuction = value;
    setFilters([...filters]);
  };

  const addNewFilterRow = () => {
    const newFilter: FilterRow = {
      //TODO this is temporary solution
      availableParameters: VBAI_FINDING_PROPERTIES,
      availableOperations: FilterConsts.availableOperations,
      availableValues: [],
      availableConjuctions: FilterConsts.availableConjunctions,
      selectedConjuction: FilterConsts.CONJ_END
    };
    setFilters([...filters, newFilter]);
  };

  return (
    <div className={style.filtersContainer}>
      {filters.map((filter, index) => (
        <div className={style.filterContainer}>
          <div className={style.filterItem}>
            <span>Parameter</span>
            <Select
              value={filter.selectedParameter}
              showSearch
              style={{ minWidth: '150px' }}
              allowClear={true}
              placeholder='Please select'
              optionFilterProp='children'
              onChange={e => updateSelectedParameter(filter, e)}
              dropdownMatchSelectWidth={false}
            >
              {filter.availableParameters.map(option => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <span>Operation</span>
            <Select
              value={filter.selectedOperation}
              showSearch
              style={{ minWidth: '150px' }}
              allowClear={true}
              placeholder='Please select'
              optionFilterProp='children'
              onChange={e => updateSelectedOperation(filter, e)}
              dropdownMatchSelectWidth={false}
            >
              {filter.availableOperations.map(option => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <span>Value</span>
            <Select
              value={filter.selectedValue}
              showSearch
              style={{ minWidth: '150px' }}
              allowClear={true}
              placeholder='Please select'
              optionFilterProp='children'
              onChange={e => updateSelectedValue(filter, e)}
              dropdownMatchSelectWidth={false}
            >
              {filter.availableValues.map(option => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <span>Conjunction</span>
            <Select
              value={filter.selectedConjuction}
              showSearch
              style={{ minWidth: '150px' }}
              allowClear={true}
              placeholder='Please select'
              optionFilterProp='children'
              onChange={e => updateSelectedConjuction(filter, e)}
              dropdownMatchSelectWidth={false}
            >
              {filter.availableConjuctions.map(option => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      ))}
      <Button style={{ alignSelf: 'flex-right' }} title='Add' type='primary' onClick={addNewFilterRow}>
        Add
      </Button>
    </div>
  );
};

export default PublishFilters;
